import React from 'react';
import { useUserRegion } from '../../hooks/useUserRegion';
import { CTAButton } from '../ui/CTAButton';
import { FadeIn } from '../ui/FadeIn';
export function FinalCTA() {
  const {
    formattedPrice,
    loading
  } = useUserRegion();
  return <section className="w-full px-4 md:px-8 py-24 bg-darkCard/30 border-t border-darkBorder relative overflow-hidden" data-id="element-100">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[500px] bg-amber/5 rounded-full blur-[120px] pointer-events-none" data-id="element-101"></div>

      <div className="max-w-3xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-102">
        <FadeIn data-id="element-103">
          <h2 className="font-playfair text-4xl md:text-5xl lg:text-6xl text-cream mb-8" data-id="element-104">
            You Have a Choice to Make.
          </h2>
          <p className="font-lato text-lg md:text-xl text-cream/80 leading-relaxed mb-12" data-id="element-105">
            You can keep guessing — wasting resin, wasting evenings, watching
            everyone else's pieces come out perfect. Or you can get the system
            that tells you exactly what to do, and what to do when it goes
            wrong.
          </p>
        </FadeIn>

        <FadeIn delay={100} className="w-full mb-16" data-id="element-106">
          <div className="bg-dark border-l-4 border-amber p-8 md:p-10 rounded-r-2xl shadow-2xl relative" data-id="element-107">
            <div className="absolute top-0 right-0 text-amber/5 text-9xl font-playfair leading-none -mt-4 -mr-4 select-none pointer-events-none" data-id="element-108">
              "
            </div>
            <p className="font-playfair italic text-2xl md:text-3xl text-amber leading-relaxed relative z-10" data-id="element-109">
              "For the cost of one bad batch of resin — you could have the
              system that makes sure it never happens again."
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={200} className="flex flex-col items-center gap-8 w-full max-w-md" data-id="element-110">
          <div className="text-center" data-id="element-111">
            <p className="text-4xl md:text-5xl font-playfair text-amber font-bold mb-2" data-id="element-112">
              {loading ? <span className="w-24 h-12 bg-amber/20 rounded animate-pulse inline-block" data-id="element-113"></span> : formattedPrice}
            </p>
            <p className="text-cream/60 font-lato text-sm uppercase tracking-wider" data-id="element-114">
              One-time payment
            </p>
          </div>

          <CTAButton formattedPrice={formattedPrice} loading={loading} size="xl" className="w-full shadow-2xl shadow-amber/20" data-id="element-115" />

          <div className="flex flex-col gap-6 text-left mt-8 font-lato text-sm text-cream/60 bg-dark/50 p-6 rounded-xl border border-darkBorder" data-id="element-116">
            <p data-id="element-117">
              <strong className="text-cream/90" data-id="element-118">P.S.</strong> You have a full
              60-day guarantee. If this doesn't change how you work with resin,
              email us and get your money back. No questions asked.
            </p>
            <p data-id="element-119">
              <strong className="text-amber" data-id="element-120">P.P.S.</strong> This launch price
              is time-sensitive. I reserve the right to close this discount
              without warning. If you're still reading — don't wait.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}